export default {
  AUTHENTICATION: {
    LOGIN: 'Login'
  }
}
